import { ProjectDto } from '@/core';
import { useMemo } from 'react';
import { sort } from '@/utils';

export const useEpicsOptions = (projectData: ProjectDto, editedSheetId: string) => {
  const usedEpics = projectData.sheets
    .filter((sheet) => sheet.id !== editedSheetId)
    .reduce((acc, sheet) => acc.concat(sheet.epics), [] as string[]);

  return useMemo(
    () =>
      projectData.epics
        .filter((epic) => !usedEpics.includes(epic.id))
        .map((epic) => ({ label: epic.name, value: epic.id }))
        .sort((a, b) => sort(a.label, b.label)),
    [projectData, usedEpics],
  );
};
